// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Lj-t","left":"styles_left__3qNIn","desktopActions":"styles_desktopActions__2QF0r","title":"styles_title__21DH8"};